import dynamic from 'next/dynamic'
import React from 'react'
import styled from 'styled-components'
import { ArrowLink } from 'lib/ArrowLink'
import { MaxWidthContainer } from 'lib/Section'
import { useCategories } from 'modules/categories/queries/useCategories'
import { SectionHeader } from './SectionHeader'

const Pill = dynamic(() => import('lib/Pill').then((res) => res.Pill))

const Container = styled(MaxWidthContainer)`
  padding: 0 var(--wide-grid-spacing);
`

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  column-gap: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
`

const PillContainer = styled.ul`
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

const NoMarginArrowLink = styled(ArrowLink)`
  display: flex;
`

export const CategorySection = () => {
  const { data } = useCategories({ onlyRoots: true })

  return (
    <Container as="section">
      <HeaderContainer>
        <SectionHeader title="Categories" />
        <NoMarginArrowLink url="/categories" label="View all" arrowPosition="right" textProps={{ size: 'ps', weight: 'medium' }} />
      </HeaderContainer>
      <PillContainer>
        {data?.categories.map((category) => (
          <li key={category.id}>
            <Pill label={category.name} href={`/categories/${category.slug}`} />
          </li>
        ))}
      </PillContainer>
    </Container>
  )
}
